import script from "./MainPageLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainPageLayout.vue?vue&type=script&lang=ts&setup=true"

import "./MainPageLayout.vue?vue&type=style&index=0&id=17aba2ca&lang=scss"

const __exports__ = script;

export default __exports__